import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import uniqueId                     from 'lodash/uniqueId';
import BootstrapTable               from 'react-bootstrap-table-next';

var products = [/*{id: 1,name: "Product1",price: 120,}*/];

var columns = [{
        dataField: "jointrom_col",
        text: "Joint Metric",
        //sort: true,
        headerStyle: () => {
            return { width: "30%", textAlign: "left" };
        }
    }];

const jointrom_label_arr = ["Left - 1st Toe Flexion", "Right - 1st Toe Flexion",  "Left - 1st Toe Extension", "Right - 1st Toe Extension","Left - Ankle Dorsiflexion", "Right - Ankle Dorsiflexion","Left - Ankle Plantarflexion","Right - Ankle Plantarflexion","Left - Ankle Eversion","Right - Ankle Eversion","Left - Ankle Inversion","Right - Ankle Inversion","Left - Knee Extension","Right - Knee Extension","Left - Knee Flexion","Right - Knee Flexion","Left - Hip Extension","Right - Hip Extension","Left - Hip Flexion","Right - Hip Flexion","Left - Hip Abduction","Right - Hip Abduction","Left - Hip Adduction","Right - Hip Adduction", "Left - Hip Internal Rotation", "Right - Hip Internal Rotation", "Left - Hip External Rotation", "Right - Hip External Rotation", "Left - Glenohumeral Flexion", "Right - Glenohumeral Flexion","Left - Glenohumeral Extension","Right - Glenohumeral Extension","Left - Glenohumeral Abduction","Right - Glenohumeral Abduction","Left - Glenohumeral Internal Rotation","Right - Glenohumeral Internal Rotation","Left - Glenohumeral External Rotation","Right - Glenohumeral External Rotation","Left - Elbow Flexion","Right - Elbow Flexion","Left - Elbow Extension","Right - Elbow Extension","Left - Wrist Flexion","Right - Wrist Flexion","Left - Wrist Extension","Right - Wrist Extension","Left - Wrist Radial Deviation","Right - Wrist Radial Deviation","Left - Wrist Ulnar Deviation","Right - Wrist Ulnar Deviation","Left - Thumb Flexion","Right - Thumb Flexion","Left - Thumb Extension","Right - Thumb Extension","Left - Thumb Abduction","Right - Thumb Abduction","Left - Thumb Adduction","Right - Thumb Adduction"]

const jointrom_data_arr  =  ["left_1st_toe_flexion", "right_1st_toe_flexion", "left_1st_toe_extension", "right_1st_toe_extension", "left_ankle_dorsiflexion", "right_ankle_dorsiflexion", "left_ankle_plantarflexion", "right_ankle_plantarflexion", "left_ankle_eversion", "right_ankle_eversion", "left_ankle_inversion", "right_ankle_inversion", "left_knee_extension", "right_knee_extension", "left_knee_flexion", "right_knee_flexion", "left_hip_extension", "right_hip_extension", "left_hip_flexion", "right_hip_flexion", "left_hip_abduction", "right_hip_abduction", "left_hip_adduction", "right_hip_adduction", "left_hip_internal_rotation", "right_hip_internal_rotation", "left_hip_external_rotation", "right_hip_external_rotation", "left_glenohumeral_flexion", "right_glenohumeral_flexion", "left_glenohumeral_extension", "right_glenohumeral_extension", "left_glenohumeral_abduction", "right_glenohumeral_abduction", "left_glenohumeral_internal_rotation", "right_glenohumeral_internal_rotation", "left_glenohumeral_external_rotation", "right_glenohumeral_external_rotation", "left_elbow_flexion", "right_elbow_flexion", "left_elbow_extension", "right_elbow_extension", "left_wrist_flexion", "right_wrist_flexion", "left_wrist_extension", "right_wrist_extension", "left_wrist_radial_deviation", " right_wrist_radial_deviation", "left_wrist_ulnar_deviation", "right_wrist_ulnar_deviation", "left_thumb_flexion", "right_thumb_flexion", "left_thumb_extension", "right_thumb_extension", "left_thumb_abduction", "right_thumb_abduction", "left_thumb_adduction", "right_thumb_adduction"]

export default class AssessJointROM extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            title:     "Joint ROM Assessment",
        }
    }

    componentDidMount() {
        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    getClientData = async () => {

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        products    = []; //reset global array for table; req'd otherwise modals don't show if you veer away from page and then back to this page

        //////   Reset column array   //////
        //  If the columns aren't reset, when a user goes from one member profile to another viewing the
        //  data table, the columns will duplicate and show dozens of extra columns

        columns = [{
                dataField: "jointrom_col",
                text: "Joint Metric",
                //sort: true,
                headerStyle: () => {
                    return { width: "30%", textAlign: "left" };
                }
            }];
        this.setState({
            loadingData: "Loading member data ... "
        })


        const results  = this.props.resultsJointROM;

        if(results) {
            var joint_data_arr = [];
            var joint_date_arr = [];
            var data      = results.data.jointrom;
            var ctr = 1;

                for(var key in data) {
                    var right_1st_toe_flexion                = data[key].right_1st_toe_flexion;
                    var right_1st_toe_extension              = data[key].right_1st_toe_extension;
                    var right_ankle_dorsiflexion             = data[key].right_ankle_dorsiflexion;
                    var right_ankle_plantarflexion           = data[key].right_ankle_plantarflexion;
                    var right_ankle_eversion                 = data[key].right_ankle_eversion;
                    var right_ankle_inversion                = data[key].right_ankle_inversion;
                    var right_knee_extension                 = data[key].right_knee_extension;
                    var right_knee_flexion                   = data[key].right_knee_flexion;
                    var right_hip_extension                  = data[key].right_hip_extension;
                    var right_hip_flexion                    = data[key].right_hip_flexion;
                    var right_hip_abduction                  = data[key].right_hip_abduction;
                    var right_hip_adduction                  = data[key].right_hip_adduction;
                    var right_glenohumeral_flexion           = data[key].right_glenohumeral_flexion;
                    var right_glenohumeral_extension         = data[key].right_glenohumeral_extension;
                    var right_glenohumeral_abduction         = data[key].right_glenohumeral_abduction;
                    var right_glenohumeral_internal_rotation = data[key].right_glenohumeral_internal_rotation;
                    var right_glenohumeral_external_rotation = data[key].right_glenohumeral_external_rotation;
                    var right_elbow_flexion                  = data[key].right_elbow_flexion;
                    var right_elbow_extension                = data[key].right_elbow_extension;
                    var right_wrist_flexion                  = data[key].right_wrist_flexion;
                    var right_wrist_extension                = data[key].right_wrist_extension;
                    var right_wrist_radial_deviation         = data[key].right_wrist_radial_deviation;
                    var right_wrist_ulnar_deviation          = data[key].right_wrist_ulnar_deviation;
                    var right_thumb_flexion                  = data[key].right_thumb_flexion;
                    var right_thumb_extension                = data[key].right_thumb_extension;
                    var right_thumb_abduction                = data[key].right_thumb_abduction;
                    var right_thumb_adduction                = data[key].right_thumb_adduction;

                    var left_1st_toe_flexion                = data[key].left_1st_toe_flexion;
                    var left_1st_toe_extension              = data[key].left_1st_toe_extension;
                    var left_ankle_dorsiflexion             = data[key].left_ankle_dorsiflexion;
                    var left_ankle_plantarflexion           = data[key].left_ankle_plantarflexion;
                    var left_ankle_eversion                 = data[key].left_ankle_eversion;
                    var left_ankle_inversion                = data[key].left_ankle_inversion;
                    var left_knee_extension                 = data[key].left_knee_extension;
                    var left_knee_flexion                   = data[key].left_knee_flexion;
                    var left_hip_extension                  = data[key].left_hip_extension;
                    var left_hip_flexion                    = data[key].left_hip_flexion;
                    var left_hip_abduction                  = data[key].left_hip_abduction;
                    var left_hip_adduction                  = data[key].left_hip_adduction;
                    var left_glenohumeral_flexion           = data[key].left_glenohumeral_flexion;
                    var left_glenohumeral_extension         = data[key].left_glenohumeral_extension;
                    var left_glenohumeral_abduction         = data[key].left_glenohumeral_abduction;
                    var left_glenohumeral_internal_rotation = data[key].left_glenohumeral_internal_rotation;
                    var left_glenohumeral_external_rotation = data[key].left_glenohumeral_external_rotation;
                    var left_elbow_flexion                  = data[key].left_elbow_flexion;
                    var left_elbow_extension                = data[key].left_elbow_extension;
                    var left_wrist_flexion                  = data[key].left_wrist_flexion;
                    var left_wrist_extension                = data[key].left_wrist_extension;
                    var left_wrist_radial_deviation         = data[key].left_wrist_radial_deviation;
                    var left_wrist_ulnar_deviation          = data[key].left_wrist_ulnar_deviation;
                    var left_thumb_flexion                  = data[key].left_thumb_flexion;
                    var left_thumb_extension                = data[key].left_thumb_extension;
                    var left_thumb_abduction                = data[key].left_thumb_abduction;
                    var left_thumb_adduction                = data[key].left_thumb_adduction;
                    var left_hip_internal_rotation          = data[key].left_hip_internal_rotation;
                    var right_hip_internal_rotation         = data[key].right_hip_internal_rotation;
                    var left_hip_external_rotation          = data[key].left_hip_external_rotation;
                    var right_hip_external_rotation         = data[key].right_hip_external_rotation;

                    var date_created     = data[key].date_created;
                    var date             = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                    joint_date_arr.push(date)
                    joint_data_arr.push([left_1st_toe_flexion,right_1st_toe_flexion,left_1st_toe_extension,right_1st_toe_extension,left_ankle_dorsiflexion,right_ankle_dorsiflexion,left_ankle_plantarflexion,right_ankle_plantarflexion,left_ankle_eversion,right_ankle_eversion,left_ankle_inversion,right_ankle_inversion,left_knee_extension,right_knee_extension,left_knee_flexion,right_knee_flexion,left_hip_extension,right_hip_extension,left_hip_flexion,right_hip_flexion,left_hip_abduction,right_hip_abduction,left_hip_adduction,right_hip_adduction,left_hip_internal_rotation, right_hip_internal_rotation, left_hip_external_rotation, right_hip_external_rotation, left_glenohumeral_flexion,right_glenohumeral_flexion,left_glenohumeral_extension,right_glenohumeral_extension,left_glenohumeral_abduction,right_glenohumeral_abduction,left_glenohumeral_internal_rotation,right_glenohumeral_internal_rotation,left_glenohumeral_external_rotation,right_glenohumeral_external_rotation,left_elbow_flexion,right_elbow_flexion,left_elbow_extension,right_elbow_extension,left_wrist_flexion,right_wrist_flexion,left_wrist_extension,right_wrist_extension,left_wrist_radial_deviation, right_wrist_radial_deviation,left_wrist_ulnar_deviation,right_wrist_ulnar_deviation,left_thumb_flexion,right_thumb_flexion,left_thumb_extension,right_thumb_extension,left_thumb_abduction,right_thumb_abduction,left_thumb_adduction,right_thumb_adduction])
                    // hide null values //
                    //if(first_name != null && last_name != null) {//}
                }

                var j_lgth = joint_data_arr.length + 1; // + 1 = add joint column name
                var data_col;
                // Create custom column name
                for(var j=0; j < 10; j++) {
                    data_col = joint_date_arr[j];
                    if(j_lgth < j+2) data_col = "--"; // a data title can't be null

                    var tmp_col = {
                        dataField: "col_date_"+j,
                        text: data_col,
                        headerStyle: () => {
                            return { width: "10%", textAlign: "center" };
                        }
                    }
                    columns.push(tmp_col)
                }
                var col0 = "- -";
                var col1 = "- -";
                var col2 = "- -";
                var col3 = "- -";
                var col4 = "- -";
                var col5 = "- -";
                var col6 = "- -";
                var col7 = "- -";
                var col8 = "- -";
                var col9 = "- -";
                var col10 = "- -";

                var j_tmp_lgth = joint_data_arr.length;

                for(var j=0; j < 58; j++) {
                    if(j_tmp_lgth >= 1) col0 = joint_data_arr[0][j] + "°";
                    if(j_tmp_lgth >= 2) col1 = joint_data_arr[1][j] + "°";
                    if(j_tmp_lgth >= 3) col2 = joint_data_arr[2][j] + "°";
                    if(j_tmp_lgth >= 4) col3 = joint_data_arr[3][j] + "°";
                    if(j_tmp_lgth >= 5) col3 = joint_data_arr[4][j] + "°";
                    if(j_tmp_lgth >= 6) col3 = joint_data_arr[5][j] + "°";
                    if(j_tmp_lgth >= 7) col3 = joint_data_arr[6][j] + "°";
                    if(j_tmp_lgth >= 8) col3 = joint_data_arr[7][j] + "°";
                    if(j_tmp_lgth >= 9) col3 = joint_data_arr[8][j] + "°";
                    if(j_tmp_lgth >= 10) col3 = joint_data_arr[9][j] + "°";

                    if(col0 == undefined) col0 = "- -";
                    if(col1 == undefined) col1 = "- -";
                    if(col2 == undefined) col2 = "- -";
                    if(col3 == undefined) col3 = "- -";
                    if(col4 == undefined) col4 = "- -";
                    if(col5 == undefined) col5 = "- -";
                    if(col6 == undefined) col6 = "- -";
                    if(col7 == undefined) col7 = "- -";
                    if(col8 == undefined) col8 = "- -";
                    if(col9 == undefined) col9 = "- -";

                    products.push({
                          id: uniqueId(), // id is required for unique keys, otherwise there's an error
                          jointrom_col: <span className="reportDashClientName" style={{fontWeight: "bold" }}>
                                                { ctr + ". " + jointrom_label_arr[j]}
                                        </span>,
                          col_date_0: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col0 }
                                        </span>,
                          col_date_1: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col1 }
                                        </span>,
                          col_date_2: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col2 }
                                        </span>,
                          col_date_3: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col3 }
                                        </span>,
                          col_date_4: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col4 }
                                        </span>,
                          col_date_5: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col5 }
                                        </span>,
                          col_date_6: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col6 }
                                        </span>,
                          col_date_7: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col7 }
                                        </span>,
                          col_date_8: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col8 }
                                        </span>,
                          col_date_9: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col9 }
                                        </span>,
                          col_date_10: <span className="reportDashClientName" style={{fontWeight: "bold" }} >
                                                { col10 }
                                        </span>
                      })
                      ctr++;
                }
        }
    }

    rowStyleFormat(row, rowIdx) {
      return { backgroundColor: rowIdx % 2 === 0 ? 'red' : 'blue' };
    }

    render() {
        var title     = this.state.title;

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="child" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>
                            <BootstrapTable keyField  = "id"
                                            key       = {uniqueId()}
                                            trStyle   = {this.rowStyleFormat()}
                                            data      = { products }
                                            columns   = { columns }
                                            striped
                                            hover
                                            //selectRow = { selectRow }
                                            />
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessJointROM.js